import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
} from "@mui/material";
import {
  ThumbUp,
  MonetizationOn,
  Category,
  VerifiedUser,
  AccountBalance,
  LocationOn,
  Business,
  School,
  SupportAgent,
  Campaign,
  ContactSupport,
} from "@mui/icons-material";
import Navbar from "../../../globals/components/Navbar";
import { useNavigate } from "react-router-dom";

const AdminSystemManagement = () => {
  const navigate = useNavigate();

  const links = [
    [
      {
        name: "Approve Bonds",
        path: "/vermost_approve_bonds",
        icon: <ThumbUp fontSize="large" />,
      },
      {
        name: "Manage Premiums",
        path: "/vermost_premiums_manager",
        icon: <MonetizationOn fontSize="large" />,
      },
    ],
    [
      {
        name: "Bond Types",
        path: "/bondtypes",
        icon: <Category fontSize="large" />,
      },
      {
        name: "Bond Numbers",
        path: "/bond_numbers",
        icon: <VerifiedUser fontSize="large" />,
      },
      {
        name: "Carriers",
        path: "/vermost_carrier_list",
        icon: <AccountBalance fontSize="large" />,
      },
      {
        name: "Announcements",
        path: "/announcements",
        icon: <Campaign fontSize="large" />,
      },
    ],
    [
      {
        name: "States",
        path: "/states",
        icon: <LocationOn fontSize="large" />,
      },
      {
        name: "Obligees",
        path: "/obligees",
        icon: <Business fontSize="large" />,
      },
    ],
    [
      {
        name: "Law Schools",
        path: "/law_schools",
        icon: <School fontSize="large" />,
      },
      {
        name: "All Enhancement Requests",
        path: "/view-enhancement-requests",
        icon: <SupportAgent fontSize="large" />,
      },
      {
        name: "Support Request",
        path: "/admin/support-requests",
        icon: <ContactSupport fontSize="large" />,
      },
    ],
  ];

  return (
    <>
      <Navbar />
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" fontWeight={800} mb={4} sx={{ color: 'black' }}>
          System Management
        </Typography>
        <Grid container spacing={3}>
          {links.flat().map((link, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 3,
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)',
                  border: '1px solid rgba(37, 99, 235, 0.2)',
                  transition: "all 0.3s ease-in-out",
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  "&:hover": {
                    boxShadow: "0 4px 16px rgba(37, 99, 235, 0.15)",
                    background: 'linear-gradient(135deg, #e9ecef 0%, #dee2e6 50%, #e9ecef 100%)',
                    transform: 'translateY(-2px)',
                    borderColor: 'rgba(37, 99, 235, 0.4)',
                  },
                }}
              >
                <CardActionArea onClick={() => navigate(link.path)}>
                  <CardContent
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      padding: 3,
                      color: "#333333",
                    }}
                  >
                    {React.cloneElement(link.icon, { style: { color: '#2563eb' } })}
                    <Typography variant="h6" fontWeight={500} sx={{ color: '#333333' }}>
                      {link.name}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default AdminSystemManagement;
